module.exports = __webpack_public_path__ + "img/inventar'.8e13bbb8.svg";